import { find } from 'lodash';

export default class EmailIngestTokenService {
    /* @ngInject */
    constructor(apiService) {
        this.apiService = apiService;
    }

    getAll() {
        return this.apiService.get(`/email-ingest-tokens`).then((result) => this.extractTokens(result.data));
    }

    create(teamId) {
        return this.apiService.post(`/email-ingest-tokens`, {
            teamId
        }).then((result) => result.data);
    }

    remove(id) {
        return this.apiService.delete(`/email-ingest-tokens/${id}`).then((result) => result.data);
    }

    getActiveByTeamId(teamId) {
        return this.getAll().then((tokens) => {
            return find(tokens || [], (token) => {
                const tokenTeamId = this.getTokenTeamId(token);

                return token
                    && `${tokenTeamId}` === `${teamId}`
                    && this.isTokenActive(token);
            }) || null;
        });
    }

    extractTokens(payload) {
        if (Array.isArray(payload)) {
            return payload;
        }

        if (payload && Array.isArray(payload.items)) {
            return payload.items;
        }

        if (payload && Array.isArray(payload.data)) {
            return payload.data;
        }

        return [];
    }

    getTokenTeamId(token) {
        if (!token) {
            return null;
        }

        if (token.teamId != null) {
            return token.teamId;
        }

        if (token.team_id != null) {
            return token.team_id;
        }

        if (token.team && token.team.id != null) {
            return token.team.id;
        }

        return null;
    }

    isTokenActive(token) {
        if (!token) {
            return false;
        }

        if (token.isActive != null) {
            return !!token.isActive;
        }

        if (token.is_active != null) {
            return !!token.is_active;
        }

        if (token.active != null) {
            return !!token.active;
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/application/service/email-ingest-token/email-ingest-token.service.js